import React, {useContext, useEffect, useState} from "react";
import beginningimg from "../image/beginning.svg";
import backicon from "../image/backicon.svg";
import desimg from "../image/destination.svg";
import Modal from "react-modal";
import successaplyingimg from "../image/succesaplying.svg";
import {UseContext} from "../context";
import {useNavigate, useParams} from "react-router-dom";
import "@neshan-maps-platform/mapbox-gl-react/dist/style.css";
import nmp_mapboxgl from "@neshan-maps-platform/mapbox-gl";
import {MapComponent, MapTypes} from "@neshan-maps-platform/mapbox-gl-react";
import "@neshan-maps-platform/mapbox-gl-react/dist/style.css";
import "./Scroll.css";
import "./Everytravelcard.polish.css";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePicker from "react-multi-date-picker";
import axios from "axios";
import {url} from "../url";
import {notification} from "antd";
import Loading from "./allcomponent/Loading";


const Everytravelcard = () => {

    const navigate = useNavigate();
    const travel = useParams()

    const [changecolorA, setChangecolorA] = useState(false);
    const [showsuccessmodal, setShowsuccessmodal] = useState(false);
    const [, setChangestatus] = useState("");
    const [finisht, setFinisht] = useState(false);


    const [requestSuccess, setRequestSuccess] = useState(false);
    const [loading, setLoading] = useState(false);

    const [data, setData] = useState({});
    const [dataLoading, setDataLoading] = useState(true);

    const {
        setShoweverytravelcard,
        setShowhis,
        setShowhistrinprogress,
        setShowtrinprogress,
    } = useContext(UseContext);




    const handleback = () => {
        navigate("/home");
    };

    function closemodalf() {
        setFinisht(false);
    }

    const handleshowhiscom = () => {
        setShoweverytravelcard(false);
        navigate("/history");
    };
    const closeshowsuccessmodal = () => {
        setShowsuccessmodal(false);
    };
    useEffect(() => {
        setDataLoading(true)
        axios
            .get(`${url}/travel/v1/get-single-travel-driver-accept/${travel.id}`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            })
            .then((res) => {
                if (res.status === 200) {
                    setData(res.data.data)
                    setDataLoading(false)
                }
            })
            .catch((error) => {
                setDataLoading(false)
            });
    }, [travel.id]);


    const successaplying = () => {
        setLoading(true)
        axios
            .put(
                `${url}/travel/v1/accept-travel-from-driver`,
                {
                    travel_id: travel.id,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                }
            )
            .then((res) => {
                setLoading(false)
                setRequestSuccess(true)
                setChangecolorA(true);
                setShowsuccessmodal(true);
                setShowtrinprogress(true);
                setShowhis(false);
                setShowhistrinprogress(true);
                setChangestatus(res.data.data.status);

            })
            .catch((error) => {
                setLoading(false)
                setRequestSuccess(false)
                if (error.response) {
                    notification.error({
                        message: "مشکلی پیش آمده است",
                        description: error.response.data.message,
                    });
                }
            });
    };

    function handlefinisht() {
        axios
            .put(
                `${url}/travel/v1/finish-travel/${travel.id}`,
                {},
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                }
            )
            .then((res) => {
                setShowtrinprogress(false);
                setShowhis(true);
                navigate("/history");
            })
            .catch((error) => {
                console.log(error);
                if (error.response) {
                    notification.error({
                        message: "مشکلی پیش آمده است",
                        description: error.response.data.message,
                    });
                }
            });
    }

    const showsuccessmodalstyle = {
        content: {
            borderRadius: "8px",
        },
        overlay: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
        },
    };
    if (window.innerWidth < 768) {
        showsuccessmodalstyle.content.width = "228px";
        showsuccessmodalstyle.content.height = "280px";
        showsuccessmodalstyle.content.margin = "auto";
        showsuccessmodalstyle.content.right = "40px";
        showsuccessmodalstyle.content.overflow = "hidden";
    } else {
        showsuccessmodalstyle.content.width = "228px";
        showsuccessmodalstyle.content.height = "280px";
        showsuccessmodalstyle.content.overflow = "hidden";
        showsuccessmodalstyle.content.top = "50%";
        showsuccessmodalstyle.content.right = "50%";
        showsuccessmodalstyle.content.transform = "translate(50%, -50%)";
    }
    // useEffect(() => {
    //   axios.get(
    //     "https://api.neshan.org/v4/static?key=YOUR_API_KEY&type=neshan&width=500&height=500&zoom=12&center=32.657307%2C51.677579&markerToken=101139.nRmybq5",
    //     {}
    //   );
    // }, []);

    //create pat
    useEffect(() => {
        if (data !== null && data.location) {
            const neshanMap = new nmp_mapboxgl.Map({
                mapType: nmp_mapboxgl.Map.mapTypes.neshanVector,
                container: "map",
                zoom: 7,
                pitch: 0,
                center: [data.location.longitude, data.location.latitude],
                minZoom: 2,
                maxZoom: 21,
                trackResize: true,
                mapKey: "web.7cc769b8dfb04fdcb6533c08ecd2b5b7",
                poi: true,
                traffic: false,
                isZoomControlsEnabled: true,
                setZoomGesturesEnabled: true,
                mapTypeControllerOptions: {
                    show: false,
                },
            });
            neshanMap?.addControl(new nmp_mapboxgl.NavigationControl(), "top-right");
            new nmp_mapboxgl.Marker()
                .setLngLat([data.location.longitude, data.location.latitude])
                .addTo(neshanMap);
        }
    }, [data]);

    return (
        <>
            {localStorage.getItem("token") !== null ? (
                <>
                    {data !== null ? (
                        <>
                            {dataLoading ? (
                                <div className="driver-trip-loading" role="status" aria-live="polite">
                                    <Loading/>
                                    <p>در انتظار دریافت اطلاعات...</p>
                                </div>
                            ) : (
                                <>
                                    {" "}
                                    <Modal
                                        isOpen={finisht}
                                        onRequestClose={closemodalf}
                                        style={showsuccessmodalstyle}
                                    >
                                        <div className="h-full items-center my-auto">
                                            <div className=" flex justify-center   relative bottom-2  ">
                                                <img alt="" src={successaplyingimg}></img>
                                            </div>
                                            <p className="text-[12px] font-bold text-center mt-4">
                                                آیا از اتمام این سفر مطمئن هستید؟
                                            </p>
                                            <div className=" grid grid-cols-2 flex mt-12">
                                                <div
                                                    className="col-span-1 flex justify-center  cursor-pointer"
                                                    onClick={handlefinisht}
                                                >
                                                    {" "}
                                                    <p className=" text-[20px] ">بله</p>
                                                </div>
                                                <div
                                                    className="col-span-1  flex justify-center cursor-pointer"
                                                    onClick={closemodalf}
                                                >
                                                    {" "}
                                                    <p className=" text-red-600 text-[20px] ">خیر</p>
                                                </div>
                                            </div>
                                        </div>
                                    </Modal>

                                    <Modal
                                        isOpen={showsuccessmodal}
                                        onRequestClose={closeshowsuccessmodal}
                                        style={showsuccessmodalstyle}
                                    >
                                        <div className=" flex justify-center items-center  relative bottom-2  ">
                                            <img alt="" src={successaplyingimg}></img>
                                        </div>
                                        <p className="text-[22px] font-medium text-center">
                                            سفر تایید شد
                                        </p>
                                        <p className="text-[14px] text-graytext font-normal text-center relative top-3">
                                            سفری که قبول کردید در قسمت سفر های در جریان شما نمایش داده
                                            می شود.
                                        </p>
                                        <div
                                            className="cursor-pointer z-30"
                                            onClick={handleshowhiscom}
                                        >
                                            {" "}
                                            <p className="text-[#FFBF18FF] font-medium text-center whitespace-nowrap relative top-10 text-[14px]">
                                                به صفحه مربوط هدایت شوید{" "}
                                            </p>
                                        </div>
                                    </Modal>


                                    <div className="driver-trip-detail w-full flex-row ">
                                        <div className="driver-trip-detail__back row-span-1 mt-4 mr-4 ">
                                            <img
                                                alt=""
                                                onClick={handleback}
                                                className="driver-trip-detail__back-icon cursor-pointer"
                                                src={backicon}
                                            ></img>
                                        </div>
                                        {data.location && data?.length !== 0 ? (
                                            <div className="driver-trip-detail__map row-span-1 mt-4 mx-4  ">
                                                <div className="driver-trip-detail__map-frame w-full h-[300px]">
                                                    <MapComponent
                                                        id="map"
                                                        options={{
                                                            mapKey: "web.7cc769b8dfb04fdcb6533c08ecd2b5b7",
                                                            mapType: MapTypes.neshanVector,
                                                            mapTypeControllerOptions: {
                                                                show: false,
                                                            },
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        ) : (
                                            <></>
                                        )}


                                        <div className='driver-trip-detail__route-card grid grid-cols-3 mt-7'>
                                            <div
                                                className='driver-trip-detail__schedule col-span-1 border-l-2 items-center border-[rgba(0, 0, 0, 0.2)]'>
                                                <div
                                                    className="flex flex-col h-full justify-center items-center gap-2 ">
                                                    <div className="mr-4 text-[14px]">
                                                        <DatePicker
                                                            calendar={persian}
                                                            locale={persian_fa}
                                                            value={data.travel_date}
                                                            readOnly
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                outline: "none",
                                                                border: "none",
                                                                width: "100px",
                                                                marginTop: "-6px",
                                                                fontSize: "16px",
                                                                marginLeft: "-12px",
                                                            }}
                                                        />
                                                    </div>

                                                    <div>
                                                        <p className="mr-5 text-[14px]"> {data.travel_hour_time} </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="driver-trip-detail__route col-span-2">

                                                <div className="flex flex-col justify-center h-full gap-4">
                                                    <div className="row-span-1 flex gap-2 w-full text-[14px]">
                                                        <img
                                                            alt=""
                                                            src={desimg}
                                                            className="h-[18px] w-[12px]  mt-4  mr-4"
                                                        ></img>
                                                        <p className="mt-3"> {data.destination_city?.name}</p>
                                                    </div>
                                                    <div className="row-span-1  flex w-full">
                                                        <img
                                                            alt=""
                                                            src={beginningimg}
                                                            className="h-[18px] w-[12px] mr-4"
                                                        ></img>

                                                        <div className="pt-1 px-2 flex flex-wrap text-[14px]">
                                                            <p className="">
                                                                {data.origin_city?.name}
                                                            </p>
                                                            <p className="">
                                                                {data.address && <>, {data.address}</>}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>


                                            </div>

                                        </div>

                                        <div className="row-span-1 mt-4">
                                            <div
                                                className="driver-trip-detail__divider border-[1px] mr-4 ml-4 h-[1px] border-[rgba(0, 0, 0, 0.2)] "></div>
                                        </div>

                                        <div className='driver-trip-detail__pricing col-span-1 mt-4 mx-5 flex gap-3 justify-between'>
                                            <div className="flex gap-2">
                                                <p className=" flex justify-start items-center text-[14px] font-medium ">
                                                    قیمت کل :
                                                </p>
                                                <div className=" flex font-medium gap-1 text-pricetxcolor">
                                                        <span
                                                            className="mt-1 text-black text-[#FFBF18FF] text-[14px]">{data.price}</span>
                                                    <span className="mt-[2px] text-black text-[14px]">تومان</span>
                                                </div>

                                            </div>

                                            <div className='flex gap-2'>
                                                <p className=" flex justify-start items-center text-[14px] font-medium ">
                                                    درآمد خالص :
                                                </p>
                                                <div className=" flex font-medium gap-1 text-pricetxcolor">
                                                        <span
                                                            className="mt-1 text-black text-[#FFBF18FF] text-[14px]">{data.price - (data.price_paid ?? 0)}</span>
                                                    <span className="mt-[2px] text-black text-[14px]">تومان</span>
                                                </div>

                                            </div>
                                        </div>


                                        <div className="row-span-1 mt-4">
                                            <div
                                                className="driver-trip-detail__divider border-[1px] mr-4 ml-4 h-[1px] border-[rgba(0, 0, 0, 0.2)] "></div>
                                        </div>


                                        <div className="driver-trip-detail__passenger flex-col flex gap-3 mr-6 mt-4">


                                            <div className="flex gap-2 ">
                                                <p className="">نام مسافر :</p>
                                                <p className="">
                                                    {data?.passenger_snapshot?.full_name}
                                                </p>
                                            </div>

                                            <div className="flex gap-2">
                                                <p className="">تعداد مسافر :</p>
                                                <p className=" ">{data?.passenger_count} نفر</p>
                                            </div>

                                            <div className="flex gap-2 ">
                                                <p className=" ">
                                                    شماره تماس مسافر :
                                                </p>
                                                <p className="">
                                                    0{data.passenger_snapshot?.mobile}
                                                </p>
                                            </div>


                                        </div>

                                    </div>


                                    <div className="driver-trip-detail__action w-full flex justify-center mt-5">
                                        <button
                                            className={`driver-trip-detail__accept w-[100%] mx-3 h-[40px] rounded-[10px] ${(loading || requestSuccess) && `cursor-not-allowed`}`}
                                            disabled={loading || requestSuccess}
                                            style={{
                                                backgroundColor: changecolorA
                                                    ? "rgba(67, 160, 72, 1)"
                                                    : "rgba(16, 14, 52, 1)",
                                            }}
                                        >
                                            <p
                                                className="text-whitecolor text-[16px]"
                                                onClick={successaplying}
                                            >
                                                {loading ?
                                                    <Loading/>
                                                    :
                                                    requestSuccess ?
                                                        "سفر قبول شده"
                                                        :
                                                        "قبول درخواست"
                                                }

                                            </p>
                                        </button>

                                    </div>

                                </>
                            )}
                        </>
                    ) : (
                        navigate("/home")
                    )}
                </>
            ) : (
                navigate("/")
            )}
        </>
    )
};
export default Everytravelcard;
